import { useState, useEffect } from 'react';
import { 
  Button,  Link, Grid, Typography, IconButton, Alert
} from '@mui/material';
import PinInput from 'react-pin-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

import { checkCode, getCode } from '../../actions/users';
import { isEmpty } from '../common/helpers';

const FormForgetPass3 = ({
  setPasos, setCodigo, setData,
  codigo, type, data
}) => {
  const [disableSMS, setDisableSMS] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDisableBtn(codigo.length!==4);
  }, [codigo]);

  const reenviar = async () => {
    setDisableSMS(true);
    const info = {
      email: data.email,
      tel: "52".concat(data.tel),
      subject: "olvido"
    }
    const res = await getCode(type, info);
    if(res){
      setData({
        ...data,
        codigo: res.codigo
      });
    } else {
      setError("Error al reenviar el código");
    }
    setTimeout(() => {
      setDisableSMS(false)
    }, 25000);
  }
  
  const recuperar = async e => {
    e.preventDefault();
    if(codigo.length !== 4){
      return setError("Deben de ser 4 dígitos");
    }
    if(type === "celular"){
      const to = "52".concat(data.tel);
      const info = {
        phonenumber: to,
        code: codigo,
      }
      setDisableBtn(true);
      const resCode = await checkCode(info);
      if(resCode){
        setPasos(4);
      } else {
        setError("Código incorrecto");
      }
    } else {
      if(data.codigo.toString() === codigo){
       setPasos(4);
      } else {
        setError("Código incorrecto");
      }
    }
  }

  return (
    <form noValidate onSubmit={recuperar}>
      <Grid item size={12}>
        <IconButton
          className="btn-icon"
          aria-label="back"
          onClick={() => setPasos(2)}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Grid>
      <Grid container sx={{my:2}} spacing={{ sx: 1}}>
        <Grid size={12} className="step1" item container direction="column">
          <Typography variant="h3" component="h3">¿Olvidaste tu contraseña?</Typography>
          <Typography component="p">Introduce el código recibido.</Typography>
        </Grid>
        <Grid item size={12}>
          <PinInput
            length={4}
            onChange={(value) => setCodigo(value)}
          />
        </Grid>
      </Grid>
      {
        !isEmpty(error) && (
          <Alert className="mss-alert" severity="error">
            <Typography component="p" color="error">{error}</Typography>
          </Alert>
        )
      }
      <Grid item size={12} sx={{mt: 3}}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          disabled={disableBtn}
        >
          Continuar
        </Button>
      </Grid>
      <Grid container>
        <Grid item size={12} sx={{mt: 3}}>
          <Typography className="link" component="p">
            <Link
              component="a"
              underline="hover"
              sx={{
                pointerEvents: disableSMS ? 'none' : 'auto',
                color: disableSMS ? 'grey.500' : 'primary.main',
                cursor: disableSMS ? 'not-allowed' : 'pointer',
                textDecoration: disableSMS ? 'none' : 'underline',
              }}
              onClick={() => reenviar()}
            >
              No recibí el código, enviar de nuevo
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </form>
  )
}

FormForgetPass3.propTypes = {
  setPasos: PropTypes.func.isRequired,
  codigo: PropTypes.any.isRequired,
  setCodigo: PropTypes.func.isRequired,
}

export default FormForgetPass3;